import { render, staticRenderFns } from "./OrganismInfoPopup.vue?vue&type=template&id=57d13a21&"
import script from "./OrganismInfoPopup.vue?vue&type=script&lang=js&"
export * from "./OrganismInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrganismInfoPopup.vue?vue&type=style&index=0&id=57d13a21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports